import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { SortType } from '@/coreInfrastructureModule/axios/generated/inventoryManage';
import { IInventoryRepository } from '@/coreInfrastructureModule/interfaces/IInventoryRepository';
import { InventoryAdapter } from '../adapters/InventoryAdapter';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { IPagingOptions } from '@/coreDomainsModule/paging';
import { PagingOptions } from '@/coreInfrastructureModule/axios/generated/orderManage';
import { FilterService } from '@/coreDomainsModule/services/filterService';
import { FilterContentItem, FreeColumnFilterContentItem } from '@/corePagesModule/filterModal/filterModal';
import { IParentBusiness } from '../domains/entities/Business';
import { InventoryTableService } from '../domains/services/inventoryTableService';
import { ISummaryData } from '../domains/entities/SummaryData';

/**
 * 在庫管理ページに必要な取引情報を取得する
 */
export class GetInventoryUseCase {
  private repository: IInventoryRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IInventoryRepository) {
    this.repository = repository;
  }

  /**
   * 在庫情報の取得
   * @param sortType - ソートタイプ
   * @param limit - 取得件数
   * @param offset - 取得開始位置
   * @param earlyPeriod - 表示期間の開始日
   * @param latterPeriod - 表示期間の終了日
   * @param sortTarget - ソート対象
   * @param filterItems - フィルターの一覧
   * @param freeColumnFilterItems - 自由欄フィルターの一覧
   */
  public async execute(
    sortType: SortType,
    limit: number,
    offset: number,
    earlyPeriod: string,
    latterPeriod: string,
    sortTarget: string,
    filterItems: FilterContentItem[],
    freeColumnFilterItems: FreeColumnFilterContentItem[] = []
  ): Promise<INetworkResult<[IParentBusiness[], ISummaryData, IPagingOptions], IError>> {
    // フロント側から指定されたフィルターをリクエスト用の形式に変換
    const [filterItem, filterInfoItem] = FilterService.convertFilterObjectWithInfo(filterItems);
    const { aggregateFreeColumns, baseFreeColumns } = FilterService.convertFreeColumnFilterItems(freeColumnFilterItems);
    const convertedSortTarget = InventoryTableService.convertHeaderKeyToParameter(sortTarget);
    const networkResult = await this.repository.get(
      sortType,
      limit,
      offset,
      earlyPeriod,
      latterPeriod,
      filterInfoItem,
      convertedSortTarget,
      filterItem,
      'arrival,inventory,customerForecast,supplierForecast,salesResult,order',
      aggregateFreeColumns,
      baseFreeColumns
    );
    switch (networkResult.status.type) {
      case 'success':
        return {
          status: {
            type: 'success',
            data: [
              InventoryAdapter.adaptAggregateBusiness(networkResult.status.data.result),
              InventoryAdapter.adaptSummaryData(networkResult.status.data.result.summaryData),
              networkResult.status.data.result.pagingOptions as PagingOptions,
            ],
          },
        };
      case 'error':
        return { status: { type: 'error', error: networkResult.status.error } };
    }
  }
}
